import '@justgiving/totaliser/src/Totaliser.scss';
import '@justgiving/totaliser/src/themes/PixelHeart/PixelHeart.scss';

import React, { FunctionComponent } from 'react';

import { gql } from '@apollo/client';
import { Totaliser } from '@justgiving/totaliser';

import { TotaliserWrapperFragment } from '../../../types/__generated__';
import usePageQuery, { buildQuery } from '../../hooks/usePageQuery';
import TotaliserWrapperSkeleton from '../TotaliserWrapperSkeleton/TotaliserWrapperSkeleton';

import './TotaliserWrapper.scss';

const FRAGMENT = buildQuery(gql`
  fragment TotaliserWrapper on Page {
    id
    targetWithCurrency {
      value
    }
    donationSummary {
      totalAmount {
        value
      }
    }
  }
`);

const TotaliserWrapper: FunctionComponent = () => {
  const { loading, error, refetch, data = null } = usePageQuery<
    TotaliserWrapperFragment
  >(FRAGMENT, {
    notifyOnNetworkStatusChange: true,
  });

  if (loading) {
    return <TotaliserWrapperSkeleton animated displayRefreshButton={false} />;
  }

  if (error) {
    return <TotaliserWrapperSkeleton onRefresh={refetch} />;
  }

  if (!data) {
    return null;
  }

  const target = data.targetWithCurrency?.value;

  if (!target) {
    return null;
  }

  const totalAmount = data.donationSummary?.totalAmount?.value ?? 0;
  const percentageOfTarget = (totalAmount / target) * 100;

  return (
    <Totaliser
      className="jg-pages-totaliser-main"
      percent={percentageOfTarget}
      size="auto"
      isAnimated
    />
  );
};

export default TotaliserWrapper;
